import * as SentrySvelte from '@sentry/svelte';
import { BrowserTracing } from '@sentry/tracing';
import type { HandleClientError } from '@sveltejs/kit';

SentrySvelte.init({
	dsn: import.meta.env.VITE_SENTRY_DSN,
	integrations: [new BrowserTracing()],
	release: __VERSION__,
	tracesSampleRate: parseFloat(import.meta.env.VITE_TRACE_SAMPLE_RATE)
});

SentrySvelte.setTag('svelteKit', 'browser');

// This will catch errors in `load` functions from `+page.ts` files
export const handleError = (({ error, event }) => {
	SentrySvelte.captureException(error, { contexts: { sveltekit: { event } } });
	const message = error instanceof Error ? error.message : 'An error occurred';
	return {
		message
	};
}) satisfies HandleClientError;
